import { render } from "./KostenabhaengigeFinanzierungRechnerBelegVergleich.pug?vue&type=template&id=78828d20&lang=pug"
import script from "./KostenabhaengigeFinanzierungRechnerBelegVergleich.js?vue&type=script&lang=js"
export * from "./KostenabhaengigeFinanzierungRechnerBelegVergleich.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__